/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Tickets_Create_SubmitInputs */

const en_settings_tickets_create_submit = /** @type {(inputs: Settings_Tickets_Create_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Submit`)
};

const zh_settings_tickets_create_submit = /** @type {(inputs: Settings_Tickets_Create_SubmitInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`提交`)
};

/**
* | output |
* | --- |
* | "Submit" |
*
* @param {Settings_Tickets_Create_SubmitInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const settings_tickets_create_submit = /** @type {((inputs?: Settings_Tickets_Create_SubmitInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Tickets_Create_SubmitInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_tickets_create_submit(inputs)
	return zh_settings_tickets_create_submit(inputs)
});
export { settings_tickets_create_submit as "settings.tickets.create_submit" }